import React from 'react';
import { MotifCheckbox } from '@ey-xd/motif-react';

export default (props) => {
  const value = props.data ? props.data[props.colDef.field] : null;
  const uniqueKey = props.data?.uniqueKey;

  return (
    <span>
      <MotifCheckbox
        type="checkbox"
        name={`ag-cell-checkbox-${props.colDef.field}-${uniqueKey}`}
        id={`ag-cell-checkbox-${props.colDef.field}-${uniqueKey}`}
        checked={value}
        tabIndex="-1"
        aria-label="Press Space to toggle row selection"
        style={{ cursor: props.isEditModeActive ? 'pointer' : 'default' }}
        onClick={() =>
          props.onCellCheckboxChange(uniqueKey, props.node, props.colDef.field)
        }
      ></MotifCheckbox>
    </span>
  );
};
